/** @format */

import { createLocales } from '@designable/core'
import { Input } from './Input'

export const Password = createLocales(Input, {
  'zh-CN': {
    title: '密码输入'
  },
  'en-US': {
    title: 'Password'
  },
  'ko-KR': {
    title: '비밀번호'
  }
})
